import React from 'react';
interface SectionProps {
  eyebrow?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'cream' | 'white' | 'ink';
  id?: string;
  children: React.ReactNode;
}
export function Section({
  eyebrow,
  title,
  subtitle,
  tone = 'cream',
  id,
  children
}: SectionProps) {
  const toneClass = tone === 'ink' ? 'bg-ink text-white' : tone === 'white' ? 'bg-white text-ink' : 'bg-cream text-ink';
  return <section id={id} className={`${toneClass} px-4 py-14 sm:py-20`} data-id="element-74" data-mp="chriuvc4dxwr">
      <div className="mx-auto w-full max-w-5xl" data-id="element-75" data-mp="hdgeinl0quns">
        {eyebrow ? <p className={`text-center text-[11px] font-extrabold uppercase tracking-[0.18em] sm:text-xs ${tone === 'ink' ? 'text-cyan-brand' : 'text-cyan-brand'}`} data-id="element-76" data-mp="2qn704hqqt65">
            {eyebrow}
          </p> : null}
        {title ? <h2 className={`mx-auto mt-3 max-w-3xl text-center font-display text-[27px] font-bold leading-[1.15] tracking-tight sm:text-4xl ${tone === 'ink' ? 'text-white' : 'text-ink'}`} data-id="element-77" data-mp="105r9lv9flobc">
            {title}
          </h2> : null}
        {subtitle ? <p className={`mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed sm:text-[17px] ${tone === 'ink' ? 'text-white/75' : 'text-ink-soft'}`} data-id="element-78" data-mp="38d5gdrruj96x">
            {subtitle}
          </p> : null}
        <div className={title || eyebrow ? 'mt-9 sm:mt-12' : ''} data-id="element-79" data-mp="3dbywlryipeas">{children}</div>
      </div>
    </section>;
}